import { treeFilter } from "@homebound/beam";
import { useMemo } from "react";
import { ItemLocationsFilter } from "src/generated/graphqlTypes";
import { useProjectLocationsTree } from "src/hooks/useProjectLocationsTree";

export function useProjectLocationsTreeFilter(projectId: string, _filter: ItemLocationsFilter = {}) {
  const locationOptions = useProjectLocationsTree(projectId, _filter);

  const filter = useMemo(
    () =>
      treeFilter({
        label: "Locations",
        filterBy: "root",
        getOptionLabel: (o) => o.name,
        getOptionValue: (o) => o.id,
        options: locationOptions,
      }),
    [locationOptions],
  );

  return filter;
}
